import { useRouter } from 'next/router'
import { Context as ContextScala } from 'scala'
import { useContext, useMemo } from 'react'
import { useResetPage } from '../../../hooks/misc/use-reset-page'
import { useTask } from '../../../hooks/tasks/use-task'
import { SplitTask } from './split'
import { Loader } from '../../../components/loader'
import { SingleTrack } from './singletrack'
import { useDefineAudioEngine } from '../../../hooks/player/use-define-audio-engine'

export const PlayerModuleContent: React.FC = () => {
  const router = useRouter()
  const taskId = router.query.taskId as string
  const { user } = useContext(ContextScala)
  const { task, error, loading, taskType, refetchTask } = useTask({ taskId })
  const resetPage = useResetPage(task?.operations)
  useDefineAudioEngine({
    type: user?.featureFlags?.webAudioEngine
  })

  const enableEditTask = useMemo(
    () => task?.playlists?.some((playlist) => !playlist?.viewOnly),
    [task]
  )

  const enableExport = useMemo(() => {
    const taskInBrandedSetlist = task?.playlists?.some(
      (i) => i?.type === 'BRANDED'
    )

    if (taskInBrandedSetlist) {
      return false
    }

    return true
  }, [task])

  if (error || resetPage || (loading && !task)) {
    return null
  }

  if (taskType === 'spliter') {
    return (
      <SplitTask
        refetchTask={refetchTask}
        enableEditTask={enableEditTask}
        enableExport={enableExport}
        {...task}
      />
    )
  }

  if (taskType === 'mastering' || taskType === 'denoiser') {
    return (
      <SingleTrack
        typeOp={taskType}
        type={taskType === 'mastering' ? 'mastered' : 'denoised'}
        enableExport={enableExport}
        refetchTask={refetchTask}
        {...task}
      />
    )
  }

  return null
}

export const PlayerModule: React.FC = () => {
  const { loadingUserInfo } = useContext(ContextScala)

  if (loadingUserInfo) {
    return <Loader />
  }

  return <PlayerModuleContent />
}
